import { useSelector, useDispatch } from "react-redux";
import { setUser, initialState } from "store/auth/userSlice";
import { apiSignIn, apiSignOut, apiSignUp } from "services/AuthService";
import { onSignInSuccess, onSignOutSuccess } from "store/auth/sessionSlice";
import appConfig from "configs/app.config";
import { REDIRECT_URL_KEY } from "constants/app.constant";
import { useNavigate } from "react-router-dom";
import useQuery from "./useQuery";
import { useGetAuthenticatedEntry } from "./useGetAuthenticatedEntryPath";

const setupAdminEnterPath = "/news";
const othersAdminPath = "/departments";

function useAuth() {
  const { authenticatedEntryPath } = useGetAuthenticatedEntry();
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const query = useQuery();

  const { token, signedIn } = useSelector((state) => state.auth.session);

  const signIn = async (values) => {
    try {
      const resp = await apiSignIn(values);
      if (resp.data.status === 0) throw new Error(resp.data.message);
      if (resp.data) {
        const { token } = resp.data.data;
        const { user } = resp?.data?.data;
        // console.log("the value of the user is -------->>", user);
        // const user = {
        //   id: 1,
        //   name: "Website Admin",
        //   email: "setupadmin@gmail.com",
        //   mobile: null,
        //   role: {
        //     id: 1,
        //     title: "Setup Admin",
        //     dev_code: "monitoring_admin",
        //   },
        //   gender: {
        //     id: 1,
        //     title: "Male",
        //     dev_code: "male",
        //   },
        // };

        localStorage.setItem("user", JSON.stringify(user));
        localStorage.setItem("token", token);

        dispatch(onSignInSuccess(token));
        if (resp?.data?.data?.user) {
          dispatch(
            setUser(
              resp?.data?.data?.user || {
                avatar: "",
                userName: "Anonymous",
                authority: ["USER"],
                email: "",
              }
            )
          );
        }
        const redirectUrl = query.get(REDIRECT_URL_KEY);

        console.log(
          "the value of user  user?.role?.dev_code is --------->>",
          user?.role?.dev_code
        );

        navigate(
          redirectUrl
            ? redirectUrl
            : user?.role?.dev_code === "setup_admin"
            ? setupAdminEnterPath
            : othersAdminPath
        );
        return {
          status: "success",
          message: "",
        };
      }
    } catch (errors) {
      return {
        status: "failed",
        message: errors?.response?.data?.message || errors.toString(),
      };
    }
  };

  const signUp = async (values) => {
    try {
      const resp = await apiSignUp(values);
      if (resp.data) {
        const { token } = resp.data;
        dispatch(onSignInSuccess(token));
        if (resp.data.user) {
          dispatch(
            setUser(
              resp.data.user || {
                avatar: "",
                userName: "Anonymous",
                authority: ["USER"],
                email: "",
              }
            )
          );
        }
        const redirectUrl = query.get(REDIRECT_URL_KEY);
        navigate(redirectUrl ? redirectUrl : authenticatedEntryPath);
        return {
          status: "success",
          message: "",
        };
      }
    } catch (errors) {
      return {
        status: "failed",
        message: errors?.response?.data?.message || errors.toString(),
      };
    }
  };

  const handleSignOut = () => {
    dispatch(onSignOutSuccess());
    dispatch(setUser(initialState));
    navigate(appConfig.unAuthenticatedEntryPath);
  };

  const signOut = async () => {
    // await apiSignOut();
    handleSignOut();
  };

  return {
    authenticated: token && signedIn,
    signIn,
    signUp,
    signOut,
  };
}

export default useAuth;
